import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
  import Swal from 'sweetalert2';

 import "react-toastify/dist/ReactToastify.css";
const InviteCustomer = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const showInviteModal = () => {
    setInviteModal(false)
    setUser('')
  }
  const [inviteModal , setInviteModal] = useState(null);
  const [preview, setPreview] = useState(null);
 
  useImperativeHandle(ref, () => ({
   showInviteModal: (foodData) => {
    if (foodData) {
      setUser(foodData);
      if (foodData.FoodImage) {
        setPreview(`https://suhba.education.com.ly/back${foodData.FoodImage}`);
      }
    }

getFoodCatigory();
    getstorage();
        setInviteModal(true)
    }

  }))    
  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
  const userid = userData.id;
  const notifyTopRight = () => {
    toast.success("✔️ تمت عملية التعديل بنجاح", {
      position: "top-right",
      autoClose: 800,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };  
  //------------------------
  const [user, setUser] = useState({
    Name: '',
    CategoryID: '',
    StorageID: '',
    ItemPrice: '',
    QuantityInStock: '1',
    UserID: userid,
    status: '',
    extension:'',
        FoodImage: null

  });

  useEffect(() => {
    
    setUser(props.data)

  }, [props.data, setUser]);
  console.log('user', user);

  //--------------------------------------------------
  const [catigorydata, setCatigorydata] = useState([])
  const [storagedata, setStoragedata] = useState([])
  

const onSubmit = ev => {
  ev.preventDefault();
const formData = new FormData();
      Object.keys(user).forEach(key => {
        if (key !== 'FoodImage') formData.append(key, user[key]);
      });
      if (user.FoodImage instanceof File) {
        formData.append('FoodImage', user.FoodImage);
      }

      const res =  axios.post(`https://suhba.education.com.ly/back/api/food_items/${user.ItemID}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
    .then(() => {
      setUser('');
      props.parentFunction();
      notifyTopRight();
      setInviteModal(false);
    })
    .catch(error => {
      let message = 'حدث خطأ أثناء تحديث البيانات.';

      if (error.response && error.response.data?.message) {
        message = error.response.data.message;
      } else if (error.request) {
        message = 'لا يوجد استجابة من الخادم. تأكد من الاتصال.';
      } else {
        message = error.message;
      }

      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text: message,
        confirmButtonText: 'موافق'
      });
    });
};

  console.log('uder', user)
  const getFoodCatigory = () => {
    axios.get('https://suhba.education.com.ly/back/api/getFoodCatigory')
      .then(({ data }) => {
        setCatigorydata(data.FoodCategory)
      })
  }
  const getstorage = () => {
    axios.get('https://suhba.education.com.ly/back/api/getstorage')
      .then(({ data }) => {
        setStoragedata(data.storageType)
      })
  }
  useEffect(() => {
    const handleEnterKey = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const form = e.target.form;
        const fields = Array.from(form.elements).filter(el => (
          (el.tagName === 'INPUT' && !el.disabled) ||
          (el.tagName === 'TEXTAREA' && !el.disabled) ||
          (el.tagName === 'SELECT' && !el.disabled)
        ));      const currentFieldIndex = fields.findIndex(el => el === document.activeElement);
        const nextFieldIndex = currentFieldIndex + 1;
        if (nextFieldIndex < fields.length) {
          fields[nextFieldIndex].focus();
        }
      }
    };
    
    document.addEventListener('keydown', handleEnterKey);
    
    return () => {
      document.removeEventListener('keydown', handleEnterKey);
    };
  }, []);
    const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUser(prev => ({ ...prev, FoodImage: file }));
      setPreview(URL.createObjectURL(file));
    }
  };

  //---------------------------------------------
  return (
    <>
      <div>
      <ToastContainer />

      </div>
      <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>


        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">تعديل بيانات الاصناف</h1>
            <button type="button" className="btn-close " style={{ marginLeft: 0 }} padding="" onClick={() => showInviteModal()}></button>
          </div>
              <div className="container mt-3">

          <form onSubmit={onSubmit}>
                   <div className="row">

                                    <div className="col-md-3">
          <div className="col-md-12"><label>صورة المنتج</label></div>
          <div className="col-md-12">
            <input type="file" accept="image/*" className="form-control" onChange={handleFileChange} />
          </div>
          <div className="col-md-12">
            {preview && <img src={preview} alt="preview" width="100" className="mt-2" />}
          </div>
        </div>                         
                         <div className="col-md-9">
        <div className="row mb-3">

                    <div className="col-xl-2 p-0">
                      <label className="form-label  ">اسم الصنف</label>
                    </div>
                    <div className="col-xl-4">
                      <div className="input-group ">
                        <input style={{ height: "2rem" }}
                          type="text"
                          pattern="[a-zA-Z\u0600-\u06FF\s]+"
                          title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"

                          required
                          id="inputcity"
                          name="Name"
                          className="form-control "
                          value={user.Name}
                          onChange={ev => setUser({ ...user, Name: ev.target.value })} />
                      </div>   </div>

                    <div className="col-xl-2">
                      <label className="form-label  ">السعر </label>
                    </div>
                    <div className="col-xl-4">
                      <div className="input-group ">
                        <input style={{ height: "2rem" }}
                          type="text"
                          pattern="\d+(\.\d{1,2})?"
                          title="الرجاء إدخال ارقام فقط"

                          required
                          id="inputcity"
                          name="ItemPrice"
                          className="form-control "
                          value={user.ItemPrice}
                          onChange={ev => setUser({ ...user, ItemPrice: ev.target.value })}
                        />
                      </div>   </div>
                 
                      </div>   
        <div className="row mb-3">

                   <div className="col-xl-2">

                    <label className="form-label mt-3">المجموعة</label>
</div>
<div className="col-xl-10">

                    <select className="default-select form-control  mt-3"
                      name="CategoryID"
                      value={user.CategoryID}
                      onChange={(ev) => setUser({ ...user, CategoryID: ev.target.value })}
                    >
                      <option value="" data-display="Select">
                        {user.CategoryID}
                      </option>
                      {catigorydata.length > 0 &&
                        catigorydata.map((row) => (
                          <option key={row.FoodCategoryID} value={row.FoodCategoryID}>
                            {row.FoodName}
                          </option>
                        ))}
                    </select>
</div>





                  <div className="col-xl-2">
                    <label className="form-label mt-3">نوع التخزين<span className="text-danger">*</span></label>
</div>
<div className="col-xl-10">

                    <select className="default-select form-control  mt-3"
                      name="StorageID"
                      value={user.StorageID}
                      onChange={(ev) => setUser({ ...user, StorageID: ev.target.value })}
                    >
                      
                      {catigorydata.length > 0 &&
                        storagedata.map((row) => (
                          <option key={row.StorageTypesID} value={row.StorageTypesID}>
                            {row.StorageTypesName}
                          </option>
                        ))}
                    </select>






                  </div>
                
             
                  <div className="col-xl-2 ">
                                        <label className="form-label mt-3 ">إضافات </label> 
                                         </div>


                                        <div className="col-xl-4">
                                        <div className="input-group ">
                                            <input style={{  height: "2rem" }} 
                                            type="text" 
                                            pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                         
                                               
                                            id="inputcity"
                                              name="extension"
                                            className="form-control mt-3" 
                                            value={user.extension} 
                                            onChange={(ev) => setUser({ ...user, extension: ev.target.value })}
                                            />
                                        </div>   </div>
</div>
                  <input type="text" hidden="true" name="UserID" value={userid} />
                  <input type="text" id="ItemID" hidden="true" name="ItemID" value={props.ItemID} />

                </div>
             
</div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-primary" >

                حفظ</button>
              <button type="button" className="btn btn-danger light" onClick={() => showInviteModal()}>إلغاء</button>

            </div>
          </form>
        </div>  </div>
      </Modal>
    </>
  )
})
export default InviteCustomer;